import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/admin/password/request", { email });
      setDone(true);
    } catch {
      // Always show generic confirmation — never leak account existence
      setDone(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] grid place-items-center px-6" data-testid="page-forgot-password">
      <SEO title="Reset admin password" path="/admin/forgot-password" />
      <div className="w-full max-w-sm bg-[#F5F5F7] rounded-3xl p-8">
        <p className="eyebrow">Admin</p>
        <h1 className="text-h3 mt-1">Reset your password</h1>
        {done ? (
          <div className="mt-6 space-y-4">
            <p className="text-sm text-[#1D1D1F]">
              If an admin account exists for that email, we just sent a reset link. Check your inbox — the link expires in 30 minutes.
            </p>
            <Link to="/admin/login" className="btn-secondary inline-block" data-testid="forgot-back-to-login">Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-sm">Admin email</label>
              <input
                required
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="forgot-email"
                className="mt-2 w-full h-12 px-4 rounded-xl bg-white focus:ring-1 focus:ring-[#0066FF] focus:outline-none"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full"
              data-testid="forgot-submit"
            >
              {loading ? "Sending..." : "Send reset link"}
            </button>
            <div className="text-center">
              <Link to="/admin/login" className="text-sm text-[#0066FF]">Back to sign in</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
